import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "index-guide"
  }, [_c('div', {
    staticClass: "index-icons"
  }), _c('div', {
    staticClass: "index-guide-info"
  }, [_c('div', {
    staticClass: "index-guide-head",
    style: {
      width: _vm.deviceType == 'android_large' || _vm.deviceType == 'ios_large' ? `${_vm.remTran(800)}rem` : `${_vm.remTran(650)}rem`
    },
    on: {
      "click": () => _vm.$router.push('/biography')
    }
  }, [_c('img', {
    staticClass: "heads",
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/index-guide-head.png`),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "light1",
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/index-guide-head-light1.png`),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "light2",
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/index-guide-head-light2.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "index-guide__name",
    style: {
      marginTop: _vm.deviceType == 'android_large' || _vm.deviceType == 'ios_large' ? `${_vm.remTran(-40)}rem` : `${_vm.remTran(-60)}rem`
    }
  }, [_vm._v("PAOLO "), _c('span', [_vm._v("Maldini")])]), _c('div', {
    staticClass: "index-guide__intro"
  }, [_vm._v("A world-class player. He is considered one of the greatest footballers in the history of the game.")])]), _c('div', {
    ref: "chatBox",
    staticClass: "index-guide-chat"
  }, [_c('div', {
    staticClass: "index-guide-chat-main"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade-move"
    }
  }, _vm._l(_vm.visibleMessages, function (item, index) {
    return _c('div', {
      key: item._uid,
      staticClass: "index-chats-a"
    }, [_c('div', {
      staticClass: "index-chats__head"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/ai.jpg`),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "index-chats__content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]);
  }), 0)], 1)]), _c('div', {
    staticClass: "index-guide-tab"
  }, [_c('div', {
    staticClass: "index-tab-item",
    on: {
      "click": function ($event) {
        return _vm.onTab(1);
      }
    }
  }, [_c('img', {
    staticClass: "guide-tab-bg",
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/tab-guide-bg-1.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "index-tab-main left"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/tab-icon-2.png`),
      "alt": ""
    }
  }), _vm._v("PAOLO TEXT CHAT")])]), _c('div', {
    staticClass: "index-tab-item",
    on: {
      "click": function ($event) {
        return _vm.onTab(0);
      }
    }
  }, [_c('img', {
    staticClass: "guide-tab-bg",
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/tab-guide-bg-2.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "index-tab-main right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/tab-icon-1.png`),
      "alt": ""
    }
  }), _vm._v("PAOLO VOICE CHAT")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };